import React from 'react';
import "./styles.css";
import {
    TextField,
    Grid,
    Typography,
  } from "@mui/material";
const Payment = () => {
    return(<Grid className='payment_container' sx={{padding:'20px', marginTop: "19px",  border: '1px solid #E3E3E3', backgroundColor: '#FCFCFC', boxShadow: "0px 3px 6px #A7A7A729",
    borderRadius: "6px"}}>
      <Typography style={{fontWeight:'600',color:'#000000', fontFamily: 'Rubik'
                     }}>
  Payment details
</Typography>
      <Grid  sx={ {display:'flex', flexDirection:'row',justifyContent:'space-between' }} >
        <Grid  sx={ {display:'flex', flexDirection:'column'}}>
        <label htmlFor="name" style={{ fontFamily: 'Rubik',color:'#000000',fontWeight:'normal', fontSize:'14px' }}>
          Account Number
        </label>
        <TextField
        // className='address_container'
          style={{ fontFamily: 'Rubik' }}
          size="small"
          disabled={false}
          focused={false}
          placeholder="Add Last Name"
          value={'12 00 22 33 44 55 55'}
          sx={{width:'270px'}}
        />
        </Grid>
        <Grid  sx={ {display:'flex', flexDirection:'column',}}>
       
      
        <label htmlFor="name" style={{ fontFamily: 'Rubik',color:'#000000',fontWeight:'normal', fontSize:'14px' }}>
          Account Holder's name
        </label>
        <TextField
        //  className='address_container'
          style={{ fontFamily: 'Rubik' }}
          disabled={false}
          focused={false}
          size="small"
          InputProps={{ readOnly: true, style: {
            backgroundColor: "white"                 
          } }}
          placeholder="Add Last Name"
          value={'JOHN D Green'}
          sx={{width:'270px'}}
        />
        </Grid>
        <Grid  sx={ {display:'flex', flexDirection:'column'}}>
        <label htmlFor="name" style={{ fontFamily: 'Rubik',color:'#000000',fontWeight:'normal', fontSize:'14px' }}>
          Bank Branch name
        </label>
        <TextField
        // className='address_container'
          style={{ fontFamily: 'Rubik' }}
          size="small"
          disabled={false}
          focused={false}
          InputProps={{ readOnly: true, style: {
            backgroundColor: "white"                 
          } }}
          placeholder="Add Last Name"
          value={'BANK NAME Pvt Ltd'}
          sx={{width:'270px'}}
        />
        </Grid>
        </Grid>
        </Grid>
    )
}

export default Payment;